import { inject, Pipe, type PipeTransform } from '@angular/core';
import { TranslateService } from '../services/i18n.service';

/**
 * `{{ 'nav.home.label' | translate }}` / `{{ 'sidebar.itemPendingAriaLabel' | translate:[label, count] }}`
 *
 * Impure so it re-evaluates whenever the active language changes, not just when the key input itself changes.
 */
@Pipe({ name: 'translate', pure: false })
export class TranslatePipe implements PipeTransform {
  readonly #translate = inject(TranslateService);

  transform(key: string, values?: string[]): string {
    return this.#translate.getKeyTranslation(key, values)();
  }
}
